import { render, staticRenderFns } from "./ClientServiceProporsalConfirmation.vue?vue&type=template&id=7c4a85f4"
import script from "./ClientServiceProporsalConfirmation.vue?vue&type=script&lang=js"
export * from "./ClientServiceProporsalConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports